module.exports = __webpack_public_path__ + "img/4.3be22671.jpg";